

























import { Component, Mixins } from "vue-property-decorator";
import { Profile } from "@/models";
import ProfileMixin from "@/mixins/http/Profile";
import ProfileEditor from "@/components/ProfileEditor.vue";

const REQUEST_TAG = "profile";

@Component({
  components: {
    ProfileEditor,
  },
})
export default class AdminProfileEdit extends Mixins(ProfileMixin) {
  profile: Profile = new Profile({});

  loading = true;

  created() {
    this.load();
  }

  async load() {
    this.loading = true;
    this.profile = await this.getProfile(this.$route.params.id, REQUEST_TAG);
    this.loading = false;
  }

  cancel() {
    this.$router.go(-1);
  }

  get saveDisabled() {
    return true;
  }

  protected onSaved() {
    this.$router.push({ name: "AdminProfile" });
  }

  protected onDeleted() {
    this.$router.push({ name: "AdminProfile" });
  }
}
